import type { ServerLoadedFeeds } from '~/services/layout/server-loaded-feeds';

type TabComponentFeed = ServerLoadedFeeds[number];

/**
 * Feed for one component on one tab.
 * Tabs that share a screen reuse component ids, so a flat search returns the first tab's feed.
 * @param tabsContentFeeds - Feeds grouped by tab, same order as the tabs feed entries
 * @param tabIndex - Index of the tab being rendered
 * @param componentId - UI component id on that tab's screen
 * @returns The matching feed, or undefined when this tab has none
 */
export function getTabComponentFeed({
  tabsContentFeeds,
  tabIndex,
  componentId,
}: {
  tabsContentFeeds: unknown[] | null | undefined;
  tabIndex: number;
  componentId: string;
}): TabComponentFeed | undefined {
  const tabFeeds: unknown = tabsContentFeeds?.[tabIndex];

  if (!Array.isArray(tabFeeds)) return undefined;

  return (tabFeeds as TabComponentFeed[]).find(
    (feed) => feed?.componentId === componentId
  );
}
